module.exports = __webpack_public_path__ + "public/1.0.1_301066/img/down.90112eb1.png";